import Vue from 'vue'
import Router from 'vue-router'
import routerConf from './router'

Vue.use(Router);
// 路由配置文件
const list = [...routerConf.list, ]

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
	mode: 'history',
    routes: list,
    base: '/',
})




// WEBPACK FOOTER //
// ./src/router/index.js